import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { audiences } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function ForWho() {
  return <section className="bg-cream-100 px-5 py-12 sm:py-20" data-id="element-85" data-mp="2ckjf63z0olng">
      <div className="mx-auto max-w-6xl" data-id="element-86" data-mp="2ciykmecpd2pl">
        <SectionHeading eyebrow="¿Para quién es?" title="Para vos, si querés que tu perro esté en paz cuando no estás" data-id="element-87" data-mp="2hc9vcqkmy3ms" />

        <ul className="mt-7 grid grid-cols-2 gap-2.5 sm:mt-12 sm:gap-5 lg:grid-cols-4" data-id="element-88" data-mp="2mal6d4mo2k6l">
          {audiences.map(audience => <li key={audience.title} className="relative flex flex-col rounded-xl bg-cream-50 p-3.5 shadow-card ring-1 ring-inset ring-forest-900/[0.07] transition-transform duration-150 ease-out hover:-translate-y-0.5 sm:rounded-2xl sm:p-6" data-id="element-89" data-mp="2vbj7nf5q0dlh">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-forest-800 sm:h-9 sm:w-9" data-id="element-90" data-mp="10zut3e3eid1m">
                <CheckIcon className="h-4 w-4 text-gold-400 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-91" data-mp="xbxsy2mvlnr4" />
              </span>
              {audience.tag ? <span className="absolute right-2.5 top-3 rounded-full bg-gold-400 px-1.5 py-0.5 text-[0.55rem] font-bold uppercase tracking-wider text-forest-950 sm:right-4 sm:top-5 sm:px-2 sm:text-[0.6rem]" data-id="element-92" data-mp="sjxz8rxefr2z">
                  {audience.tag}
                </span> : null}
              <h3 className="mt-3 font-display text-[0.9rem] leading-tight text-forest-900 sm:mt-5 sm:text-lg" style={{
            fontWeight: 600
          }} data-id="element-93" data-mp="1g9saj522l7l4">
                {audience.title}
              </h3>
              <p className="mt-1.5 text-[0.72rem] leading-snug text-forest-900/60 sm:mt-2 sm:text-sm sm:leading-relaxed" data-id="element-94" data-mp="17c87prok738e">
                {audience.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-6 text-center text-xs text-forest-900/70 sm:mt-10 sm:text-sm" data-id="element-95" data-mp="3n1jcyi80j70y">
          ¿No estás seguro si es para vos?{' '}
          <a href="#garantia" className="inline-flex items-center gap-1 font-semibold text-forest-700 underline decoration-gold-400 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-forest-900" data-id="element-96" data-mp="3ojqcesaob2e0">
            Tenés 7 días de garantía
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="3jikkgwou7j5j" />
          </a>
        </p>
      </div>
    </section>;
}